"use strict";

var e = require("tslib"),
  r = require("react");
exports.useDomReady = function () {
  var t = e.__read(r.useState(!1), 2),
    u = t[0],
    s = t[1];
  return r.useEffect(function () {
    s(!0);
  }, []), u;
};